<template>
    <div class="icoButton" data-icoTarget="left" @click="panel.$emit('update:show', false)"></div>
</template>

<script>
    export default {
        name: 'PanelMixinBack',
        inject: ['panel'],
    };
</script>
